<template>
  <HourlyChauffeur />
</template>
<script>
import HourlyChauffeur from "@/components/master/hourlyTariff/HourlyChauffeur";
export default {
  components: {
    HourlyChauffeur,
  },
  updated() {
    this.$helper.collapseMenu("buying-tariff");
    this.$helper.setNavigationClass("buying-rental-chauffeur-link-new");
  },
};
</script>


// WEBPACK FOOTER //
// src/components/master/buyingTariff/HourlyChauffeurBuying.vue